import { render, staticRenderFns } from "./tableForm.vue?vue&type=template&id=76acb01e&scoped=true"
import script from "./tableForm.vue?vue&type=script&lang=js"
export * from "./tableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76acb01e",
  null
  
)

export default component.exports